<template>
  <!-- Email intercept notice - normal flow -->
  <v-banner
    v-if="appStore.emailIntercept && props.showEmailIntercept"
    :bg-color="'#FFC107'"
    :color="'#121212'"
    class="mb-2 email-intercept-banner"
    >
    <template v-slot:text>
      <span class="text-body-1">An email intercept is set for <strong>{{  appStore.emailIntercept }}</strong>. All system emails will go to that address, rather than to users</span>
    </template>
  </v-banner>

  <!-- Status messages - centered popup dialog -->
  <v-dialog
    v-model="hasStatuses"
    persistent
    max-width="500"
    class="status-dialog"
  >
    <div class="status-cards-container">
      <v-card
        v-for="(status, index) in appStore.statuses"
        :key="index"
        class="mb-3 status-card"
        elevation="2"
      >
        <!-- Top half - colored background -->
        <div
          class="status-message-section"
          :style="{ backgroundColor: getStatusColor(status.type) }"
        >
          <div class="pa-6 d-flex align-center" style="min-height: 80px;">
            <span class="text-body-1 text-white">{{ status.message }}</span>
          </div>
        </div>
        <!-- Bottom half - white background with button -->
        <div class="status-action-section pa-4">
          <div class="d-flex justify-end">
            <v-btn
              :color="getStatusColor(status.type)"
              variant="flat"
              @click="appStore.clearStatus(index)"
            >
              Dismiss
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script setup>
  import { computed, watch, onBeforeUnmount } from 'vue'
  import { useAppStore } from '@/stores/app'
  const appStore = useAppStore(),
    props = defineProps(['showEmailIntercept'])

  const hasStatuses = computed(() => {
    return Object.keys(appStore.statuses).length > 0
  })

  const getStatusColor = type => {
    const green = '#43A047',
      red = '#F44336',
      blue = '#00BCD4',
      yellow = '#FFC107',
      violet = '#9C27B0'
    if ( !type || type == 'success' ) {
      return green
    } else if (type == 'danger') {
      return red
    } else if (type == 'info') {
      return blue
    } else if (type == 'warning') {
      return yellow
    } else {
      return violet
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && hasStatuses.value) {
      // Clear all statuses when ESC is pressed
      appStore.clearAllStatuses()
    }
  }

  // Add/remove event listener when statuses change
  watch(hasStatuses, (newVal) => {
    if (newVal) {
      window.addEventListener('keydown', handleKeyDown)
    } else {
      window.removeEventListener('keydown', handleKeyDown)
    }
  })

  // Clean up on unmount
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })
</script>

<style scoped>
.status-cards-container {
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.status-card {
  min-height: 150px;
  overflow: hidden;
}

.status-message-section {
  flex: 1;
}

.status-action-section {
  background-color: white;
}
</style>
